import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = ["element-loading-text"]
const _hoisted_3 = { class: "login-form-wrapper" }
const _hoisted_4 = { class: "copyright" }

import {onMounted, ref} from 'vue';
import {FormInstance, FormRules} from 'element-plus';
import { User, Lock } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router';
import {authApi } from "@/api";
import {handleApiError} from "@/utils/error";
import {UserInfo, useUserStore} from "@/stores/user";

export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore();

// 页面挂载时从本地存储读取用户名回填
onMounted(() => {
  const savedUsername = localStorage.getItem('loginUsername');
  if (savedUsername) {
    loginForm.value.username = savedUsername;
  }
});

// 表单实例
const loginFormRef = ref<FormInstance>();
const version = ref('1.13.24')

const loginLoading = ref(false)
const loginLoadingTxt = ref('')

// 表单数据
const loginForm = ref({
  username: '', // 手机号码
  password: '', // 密码
  terminal: 'PC'
});

// 表单校验规则
const loginRules = ref<FormRules>({
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
  ]
});

// 登录方法
const handleLogin = async () => {
  //await router.push('/index/home');
  userStore.clearToken();
  if (!loginFormRef.value) return;
  try {
    await loginFormRef.value.validate();
    loginLoading.value = true;
    loginLoadingTxt.value = '正在登录...';
    const response:UserInfo = await authApi.loginAuth(loginForm.value);
    userStore.setToken(response.token);
    userStore.setUserInfo(response);
    localStorage.setItem('loginUsername', loginForm.value.username);
    await router.push('/index/home');
  } catch (error) {
    handleApiError(error);
  }finally {
    loginLoading.value = false
    loginLoadingTxt.value = ''
  }
};


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "login-bg-section" }, null, -1)),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "login-form-section",
      "element-loading-text": loginLoadingTxt.value
    }, [
      _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "main-title" }, "收银数据集成系统", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "login-title" }, "用户登录", -1)),
        _createVNode(_component_el_form, {
          ref_key: "loginFormRef",
          ref: loginFormRef,
          model: loginForm.value,
          rules: loginRules.value,
          class: "login-form",
          size: "large"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { prop: "username" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginForm.value.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.value.username) = $event)),
                  placeholder: "请输入用户名",
                  "prefix-icon": _unref(User),
                  type: "text"
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: loginForm.value.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.value.password) = $event)),
                  placeholder: "请输入密码",
                  "prefix-icon": _unref(Lock),
                  "show-password": ""
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "btn-group" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "large",
                  class: "login-btn",
                  onClick: handleLogin,
                  block: "",
                  disabled: loginLoading.value
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" 登录 ")
                  ])),
                  _: 1,
                  __: [2]
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createElementVNode("div", null, "© 2026 收银数据集成系统 版权所有 | All Rights Reserved", -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", null, "© 数据安全为本，严守行业合规规范，合规保障", -1)),
        _createElementVNode("div", null, "Developer: Xiong    Version: " + _toDisplayString(version.value), 1)
      ])
    ], 8, _hoisted_2)), [
      [_directive_loading, loginLoading.value]
    ])
  ]))
}
}

})